module.exports = (__webpack_public_path__ || '') + "static/images/photo-7-1f2989d211739904f1638f824c9f9895.jpg";